import React, { useEffect } from "react";
import { ClipboardList } from "lucide-react";
import { useForm, Controller } from "react-hook-form";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";

const AddDispositionModal = ({ isOpen, onClose, onSave, itemData }) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      disposition: "",
      sub_disposition: "",
    },
  });
  useEffect(() => {
    if (itemData) {
      reset({
        disposition: itemData.disposition || "",
        sub_disposition: itemData.sub_disposition || "",
      });
    } else {
      reset();
    }
  }, [itemData, isOpen, reset]);

  const onSubmit = (data) => {
    const payload = {
      disposition: data.disposition.trim(),
      sub_disposition: data.sub_disposition.trim(),
    };

    onSave(payload);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={itemData ? "Edit Disposition" : "Add Disposition"}
      subtitle="Configure call disposition and optional sub-disposition"
      icon={<ClipboardList size={20} color="#2563eb" />}
      maxWidth="500px"
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", width: "100%" }}>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" form="dispositionForm">
            {itemData ? "Update" : "Save"}
          </Button>
        </div>
      }
    >
      <form
        id="dispositionForm"
        onSubmit={handleSubmit(onSubmit)}
        style={{ display: "flex", flexDirection: "column", gap: "14px" }}
      >
        <div>
          <label style={{ fontWeight: 600, fontSize: "13px", marginBottom: "6px", display: "block", color: "#334155" }}>
            Disposition <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <Controller
            name="disposition"
            control={control}
            rules={{ required: "Disposition is required" }}
            render={({ field }) => (
              <input
                {...field}
                className={`form-control ${errors.disposition ? "error" : ""}`}
                placeholder="Enter disposition"
                autoFocus
              />
            )}
          />
          {errors.disposition && (
            <p className="error-text" style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>
              {errors.disposition.message}
            </p>
          )}
        </div>

        <div>
          <label style={{ fontWeight: 600, fontSize: "13px", marginBottom: "6px", display: "block", color: "#334155" }}>
            Sub Disposition
          </label>
          <Controller
            name="sub_disposition"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                className="form-control"
                placeholder="Enter sub disposition (optional)"
              />
            )}
          />
        </div>
      </form>
    </Modal>
  );
};

export default AddDispositionModal;

